module.exports = __webpack_public_path__ + "img/0-1.f49108bb.png";